import script from "./UploadQueue.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadQueue.vue?vue&type=script&lang=ts&setup=true"

import "./UploadQueue.vue?vue&type=style&index=0&id=1e137190&scoped=true&lang=scss"

import exportComponent from "/var/build/production/tenants-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e137190"]])

export default __exports__